import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import AddressTypeForm from './AddressTypeForm';

const AddressTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const AddressTypeEdit = (props: any) => {
  return (
    <Edit actions={<AddressTypeActions {...props} />} {...props}>
      <AddressTypeForm />
    </Edit>
  );
};

export default AddressTypeEdit;
